// extracted by mini-css-extract-plugin
module.exports = {"optionPart":"OptionPart_optionPart__1o0tD","icon":"OptionPart_icon__1pZEA"};